(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-thalune"]) return;
  try {
    
  (() => {
    const OPEN_CLASS = 'is-open';
    const MENU_OPEN_CLASS = 'is-menu-open';
    const SEARCH_OPEN_CLASS = 'is-search-open';

    function getDirectPanel(item) {
      return Array.from(item.children).find((child) => child.matches('[data-accordion-panel]'));
    }

    function updateHeaderBottom(header) {
      if (!header) return;
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      header.style.setProperty('--thalune-header-bottom', `${bottom}px`);
    }

    function updateSearchClearState(bar, open) {
      const input = bar.querySelector('[data-search-input]');
      const clear = bar.querySelector('[data-search-clear]');
      if (!input || !clear) return;

      const hasValue = input.value.length > 0;
      clear.hidden = !hasValue;
      clear.setAttribute('tabindex', open && hasValue ? '0' : '-1');
    }

    function setSearchOpen(header, open, shouldFocus) {
      const toggle = header.querySelector('[data-search-toggle]');
      const bar = header.querySelector('[data-search-bar]');
      if (!toggle || !bar) return;

      const input = bar.querySelector('[data-search-input]');
      const submit = bar.querySelector('[data-search-submit]');

      header.classList.toggle(SEARCH_OPEN_CLASS, open);
      bar.classList.toggle(OPEN_CLASS, open);
      bar.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      [input, submit].forEach((element) => {
        if (!element) return;
        if (open) {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', '-1');
        }
      });

      updateSearchClearState(bar, open);

      if (open) setMenuOpen(header, false);
      if (open && shouldFocus && input) input.focus();
    }

    function initHeaderSearch(header) {
      if (!header || header.dataset.searchReady === 'true') return;

      const toggle = header.querySelector('[data-search-toggle]');
      const bar = header.querySelector('[data-search-bar]');
      const input = bar ? bar.querySelector('[data-search-input]') : null;
      const clear = bar ? bar.querySelector('[data-search-clear]') : null;

      if (!toggle || !bar) return;

      header.dataset.searchReady = 'true';
      updateSearchClearState(bar, false);

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        closeHeaderDropdowns(header);
        setSearchOpen(header, !bar.classList.contains(OPEN_CLASS), true);
      });

      if (input) {
        input.addEventListener('input', () => updateSearchClearState(bar, bar.classList.contains(OPEN_CLASS)));
      }

      if (clear && input) {
        clear.addEventListener('click', () => {
          input.value = '';
          updateSearchClearState(bar, true);
          input.focus();
        });
      }

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) setSearchOpen(header, false, false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (!bar.classList.contains(OPEN_CLASS)) return;
        setSearchOpen(header, false, false);
        toggle.focus();
      });
    }

    function setDropdownOpen(header, item, open) {
      const trigger = item.querySelector('[data-nav-link]');
      const dropdown = item.querySelector('[data-dropdown]');
      if (!dropdown) return;

      if (open) {
        updateHeaderBottom(header);
        closeHeaderDropdowns(header, item);
        setSearchOpen(header, false, false);
        setMenuOpen(header, false);
      }

      item.classList.toggle(OPEN_CLASS, open);
      dropdown.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeHeaderDropdowns(header, exceptItem) {
      header.querySelectorAll('[data-nav-item].is-open').forEach((item) => {
        if (item === exceptItem) return;
        item.classList.remove(OPEN_CLASS);
        const trigger = item.querySelector('[data-nav-link]');
        const dropdown = item.querySelector('[data-dropdown]');
        if (dropdown) dropdown.setAttribute('aria-hidden', 'true');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function initHeaderDropdowns(header) {
      if (!header || header.dataset.dropdownReady === 'true') return;

      const items = header.querySelectorAll('[data-nav-item]');
      if (!items.length) return;

      header.dataset.dropdownReady = 'true';
      updateHeaderBottom(header);

      items.forEach((item) => {
        const trigger = item.querySelector('[data-nav-link]');
        const dropdown = item.querySelector('[data-dropdown]');
        if (!trigger || !dropdown) return;

        dropdown.setAttribute('aria-hidden', 'true');

        item.addEventListener('mouseenter', () => {
          if (trigger.tagName === 'A' && window.matchMedia('(min-width: 990px)').matches) {
            setDropdownOpen(header, item, true);
          }
        });

        item.addEventListener('mouseleave', () => {
          if (trigger.tagName === 'A' && window.matchMedia('(min-width: 990px)').matches) {
            setDropdownOpen(header, item, false);
          }
        });

        item.addEventListener('focusin', () => {
          if (trigger.tagName === 'A') setDropdownOpen(header, item, true);
        });
        item.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!item.contains(document.activeElement)) setDropdownOpen(header, item, false);
          }, 0);
        });

        trigger.addEventListener('click', (event) => {
          if (trigger.tagName !== 'BUTTON') return;

          event.preventDefault();
          setDropdownOpen(header, item, !item.classList.contains(OPEN_CLASS));
        });

        trigger.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown' && event.key !== ' ') return;
          event.preventDefault();
          setDropdownOpen(header, item, true);
          const firstLink = dropdown.querySelector('a');
          if (firstLink) firstLink.focus();
        });
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) closeHeaderDropdowns(header);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openItem = header.querySelector('[data-nav-item].is-open');
        const openTrigger = openItem ? openItem.querySelector('[data-nav-link]') : null;
        closeHeaderDropdowns(header);
        if (openTrigger) openTrigger.focus();
      });

      let positionFrame;
      const syncHeaderPosition = () => {
        if (positionFrame) return;
        positionFrame = window.requestAnimationFrame(() => {
          updateHeaderBottom(header);
          positionFrame = null;
        });
      };

      window.addEventListener('resize', syncHeaderPosition);
      window.addEventListener('scroll', syncHeaderPosition, { passive: true });
    }

    function lockMenuPage(header, open) {
      if (open && !header._thaluneScrollLock) {
        const body = document.body;
        const properties = ['position', 'top', 'left', 'right', 'width', 'overflow', 'paddingRight'];
        const priorStyle = Object.fromEntries(properties.map((key) => [key, body.style[key]]));
        const inertElements = Array.from(document.querySelectorAll('main, footer')).filter((element) => !element.contains(header));
        header._thaluneScrollLock = { x: window.scrollX, y: window.scrollY, priorStyle, inertElements: inertElements.map((element) => [element, element.inert]) };
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbar > 0) body.style.paddingRight = `${parseFloat(getComputedStyle(body).paddingRight) + scrollbar}px`;
        body.style.position = 'fixed';
        body.style.top = `-${header._thaluneScrollLock.y}px`;
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
        inertElements.forEach((element) => { element.inert = true; });
      } else if (!open && header._thaluneScrollLock) {
        const saved = header._thaluneScrollLock;
        Object.entries(saved.priorStyle).forEach(([key, value]) => { document.body.style[key] = value; });
        saved.inertElements.forEach(([element, inert]) => { element.inert = inert; });
        delete header._thaluneScrollLock;
        header._thaluneLastScroll = saved.y;
        const scrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(saved.x, saved.y);
        document.documentElement.style.scrollBehavior = scrollBehavior;
      }
      document.body.classList.toggle('thalune-mobile-menu-open', open);
      document.dispatchEvent(new CustomEvent('thalune:menu-toggle', { detail: { open } }));
    }

    function setMenuOpen(header, open) {
      const toggle = header.querySelector('[data-menu-toggle]');
      const menu = header.querySelector('[data-mobile-menu]');
      if (!toggle || !menu) return;
      const wasOpen = header.classList.contains(MENU_OPEN_CLASS);
      header.classList.toggle(MENU_OPEN_CLASS, open);
      if (open) header.classList.remove('is-scroll-hidden');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.classList.toggle(OPEN_CLASS, open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      menu.inert = !open;
      if (open) {
        closeHeaderDropdowns(header);
        setSearchOpen(header, false, false);
      }
      if (open !== wasOpen) lockMenuPage(header, open);
      updateHeaderBottom(header);
    }

    function initHeaderMobileMenu(header) {
      if (!header || header.dataset.menuReady === 'true') return;
      const toggle = header.querySelector('[data-menu-toggle]');
      const menu = header.querySelector('[data-mobile-menu]');
      if (!toggle || !menu) return;
      header.dataset.menuReady = 'true';
      menu.inert = true;
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const open = !header.classList.contains(MENU_OPEN_CLASS);
        setMenuOpen(header, open);
        if (open) menu.querySelector('a, button')?.focus();
      });
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          setMenuOpen(header, false);
          if (link.pathname === window.location.pathname && link.hash) {
            window.requestAnimationFrame(() => document.getElementById(link.hash.slice(1))?.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
          }
        });
      });
      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) setMenuOpen(header, false);
      });
      document.addEventListener('keydown', (event) => {
        if (!header.classList.contains(MENU_OPEN_CLASS)) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          setMenuOpen(header, false);
          toggle.focus();
        } else if (event.key === 'Tab') {
          const focusable = Array.from(header.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter((element) => !element.closest('[inert]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      });
      window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 990px)').matches) setMenuOpen(header, false);
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(header)) setMenuOpen(header, false);
      });
    }

    function initHeaderScroll(header) {
      if (!header || header.dataset.scrollReady === 'true') return;
      header.dataset.scrollReady = 'true';
      header._thaluneLastScroll = window.scrollY;
      let frame = null;
      const update = () => {
        frame = null;
        const y = Math.max(0, window.scrollY);
        const delta = y - header._thaluneLastScroll;
        const engaged = header.matches('.is-menu-open, .is-search-open') || header.querySelector('[data-nav-item].is-open') || header.contains(document.activeElement);
        if (window.matchMedia('(min-width: 990px)').matches || engaged || y < 100) {
          header.classList.remove('is-scroll-hidden');
        } else if (Math.abs(delta) > 6) {
          header.classList.toggle('is-scroll-hidden', delta > 0);
        }
        if (Math.abs(delta) > 6 || engaged) header._thaluneLastScroll = y;
      };
      window.addEventListener('scroll', () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      header.addEventListener('focusin', () => header.classList.remove('is-scroll-hidden'));
    }

    function initHeaderAccordions(header) {
      if (!header || header.dataset.accordionReady === 'true') return;

      const toggles = header.querySelectorAll('[data-accordion-toggle]');
      if (!toggles.length) return;

      header.dataset.accordionReady = 'true';

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const item = toggle.closest('[data-accordion]');
          if (!item) return;

          const panel = getDirectPanel(item);
          const isOpen = !item.classList.contains(OPEN_CLASS);

          if (isOpen) {
            header.querySelectorAll('[data-accordion].is-open').forEach((openItem) => {
              if (openItem === item) return;
              openItem.classList.remove(OPEN_CLASS);
              const openToggle = openItem.querySelector('[data-accordion-toggle]');
              const openPanel = getDirectPanel(openItem);
              if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
              if (openPanel) openPanel.classList.remove(OPEN_CLASS);
            });
          }

          item.classList.toggle(OPEN_CLASS, isOpen);
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if (panel) panel.classList.toggle(OPEN_CLASS, isOpen);
        });
      });
    }


    function updateHeaderCartCount(header, cart) {
      const button = header?.querySelector('[data-cart-shell] .thalune-bag-btn');
      const count = Number(cart?.item_count);
      if (!button || !Number.isFinite(count)) return;

      let badge = button.querySelector('.thalune-cart-badge');
      if (count > 0 && !badge) {
        badge = document.createElement('span');
        badge.className = 'thalune-cart-badge';
        badge.setAttribute('aria-hidden', 'true');
        button.appendChild(badge);
      }

      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count < 1;
      }

      const label = button.querySelector('.visually-hidden')?.textContent.trim() || 'Bag';
      button.setAttribute('aria-label', count > 0 ? `${label} ${count}` : label);
    }

    async function refreshHeaderCart(header, cart) {
      if (!header) return;

      updateHeaderCartCount(header, cart);

      const sectionId = header.dataset.sectionId;
      const currentShell = header.querySelector('[data-cart-shell]');
      if (!sectionId || !currentShell) return;

      if (header._thaluneCartController) header._thaluneCartController.abort();
      const controller = new AbortController();
      header._thaluneCartController = controller;
      currentShell.setAttribute('aria-busy', 'true');

      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const url = new URL(rootUrl, window.location.origin);
        url.searchParams.set('sections', sectionId);

        const response = await fetch(url.toString(), {
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error(`Cart section request failed with status ${response.status}`);

        const sections = await response.json();
        const html = sections?.[sectionId];
        if (!html) throw new Error('Cart section response did not include the header.');

        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const freshHeader = documentFragment.querySelector('.thalune-header[data-section-id]');
        const freshShell = freshHeader?.querySelector('[data-cart-shell]');
        const currentButton = currentShell.querySelector('.thalune-bag-btn');
        const currentDropdown = currentShell.querySelector('.thalune-dropdown--bag');
        const freshButton = freshShell?.querySelector('.thalune-bag-btn');
        const freshDropdown = freshShell?.querySelector('.thalune-dropdown--bag');

        if (!currentButton || !currentDropdown || !freshButton || !freshDropdown) {
          throw new Error('Cart section markup was incomplete.');
        }

        currentButton.innerHTML = freshButton.innerHTML;
        currentButton.setAttribute('aria-label', freshButton.getAttribute('aria-label') || 'Bag');
        currentDropdown.innerHTML = freshDropdown.innerHTML;
        header.dataset.cartStale = 'false';
      } catch (error) {
        if (error.name !== 'AbortError') {
          header.dataset.cartStale = 'true';
          console.warn('[THALUNE] The bag preview could not be refreshed.', error);
        }
      } finally {
        if (header._thaluneCartController === controller) {
          delete header._thaluneCartController;
          currentShell.removeAttribute('aria-busy');
        }
      }
    }

    function initHeaderCartSync(header) {
      if (!header || header.dataset.cartSyncReady === 'true') return;
      header.dataset.cartSyncReady = 'true';

      document.addEventListener('thalune:cart-updated', (event) => {
        refreshHeaderCart(header, event.detail?.cart);
      });
    }

    function initAllHeaders() {
      document.querySelectorAll('.thalune-header[data-section-id]').forEach((header) => {
        initHeaderSearch(header);
        initHeaderDropdowns(header);
        initHeaderMobileMenu(header);
        initHeaderAccordions(header);
        initHeaderCartSync(header);
        initHeaderScroll(header);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllHeaders);
    } else {
      initAllHeaders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const header = event.target.matches('.thalune-header[data-section-id]')
        ? event.target
        : event.target.querySelector('.thalune-header[data-section-id]');
      initHeaderSearch(header);
      initHeaderDropdowns(header);
      initHeaderMobileMenu(header);
      initHeaderAccordions(header);
      initHeaderCartSync(header);
      initHeaderScroll(header);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symbol-featured-products-refresh"]) return;
  try {
    
  const syncZodiacCollectionGrid = (hasResult) => {
    document.querySelectorAll('[data-zodiac-collection-grid]').forEach((grid) => {
      const cards = Array.from(grid.querySelectorAll('[data-zodiac-card]'));
      cards.forEach((card) => { card.hidden = hasResult && card.dataset.zodiacCard === 'paired'; });
      const hasVisibleCards = cards.some((card) => !card.hidden);
      grid.hidden = !hasVisibleCards;
      grid.classList.toggle('symbol-featured-refresh__grid--other', hasResult && hasVisibleCards);
      const heading = grid.parentElement.querySelector('[data-zodiac-other-heading]');
      if (heading) heading.hidden = !hasResult || !hasVisibleCards;
    });
  };
  document.addEventListener('thalune:zodiac-result', (event) => syncZodiacCollectionGrid(event.detail?.hasResult === true));
  syncZodiacCollectionGrid(document.querySelector('#zodiac-tool')?.dataset.hasResult === 'true');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zodiac-check-tool"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MIN_INPUT_YEAR = 1900;
    const MAX_INPUT_YEAR = 2100;
    const DATA_BASE_YEAR = 1899;
    const DATA_LAST_YEAR = 2100;
    const MONTH_NAMES = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    /*
     * Local, versioned lunar boundary data.
     * schema_version: 1.0.0
     * coverage: 1899-2100
     * source: Hong Kong Observatory Gregorian-Lunar Calendar Conversion Table
     *         (1901-2100), with 1899-1900 reviewed against Taipei Astronomical
     *         Museum calendar tables.
     * source_version: 2026-08-18-review
     * updated_at: 2026-08-18
     * Each value is MMDD, indexed from DATA_BASE_YEAR.
     */
    const CNY_MMDD = [
      210,
      131,219,208,129,216,204,125,213,202,122,210,130,218,206,126,214,203,123,211,201,
      220,208,128,216,205,124,213,202,123,210,130,217,206,126,214,204,124,211,131,219,
      208,127,215,205,125,213,202,122,210,129,217,206,127,214,203,124,212,131,218,208,
      128,215,205,125,213,202,121,209,130,217,206,127,215,203,123,211,131,218,207,128,
      216,205,125,213,202,220,209,129,217,206,127,215,204,123,210,131,219,207,128,216,
      205,124,212,201,122,209,129,218,207,126,214,203,123,210,131,219,208,128,216,205,
      125,212,201,122,210,129,217,206,126,213,203,123,211,131,219,208,128,215,204,124,
      212,201,122,210,130,217,206,126,214,202,123,211,201,219,208,128,215,204,124,212,
      202,121,209,129,217,205,126,214,203,123,211,131,219,207,127,215,205,124,212,202,
      122,209,129,217,206,126,214,203,124,210,130,218,207,127,215,205,125,212,201,121,209
    ];

    const ZODIAC = [
      {
        key: 'rat', nameEn: 'Rat', nameZh: '鼠', identity: 'Resourcefulness',
        traits: ['attentiveness', 'adaptability', 'beginnings'],
        descriptionEn: 'A cultural symbol of attentive beginnings and adaptability, offered as a personal reflection rather than a fixed character judgment.',
        descriptionZh: '代表敏锐、适应与新起点的文化符号，用于个人理解与反思，不构成固定性格判断。'
      },
      {
        key: 'ox', nameEn: 'Ox', nameZh: '牛', identity: 'Steadiness',
        traits: ['patience', 'discipline', 'grounded progress'],
        descriptionEn: 'A cultural symbol of patience and steady effort, offered as a personal reflection rather than a promise of outcome.',
        descriptionZh: '代表耐心、踏实与持续行动的文化符号，用于个人理解与反思，不代表结果承诺。'
      },
      {
        key: 'tiger', nameEn: 'Tiger', nameZh: '虎', identity: 'Courage',
        traits: ['initiative', 'presence', 'exploration'],
        descriptionEn: 'A cultural symbol of initiative and courageous presence, offered as a personal reflection rather than a fixed character judgment.',
        descriptionZh: '代表主动、勇气与探索精神的文化符号，用于个人理解与反思，不构成固定性格判断。'
      },
      {
        key: 'rabbit', nameEn: 'Rabbit', nameZh: '兔', identity: 'Grace',
        traits: ['sensitivity', 'diplomacy', 'renewal'],
        descriptionEn: 'A cultural symbol of sensitivity and graceful renewal, offered as a personal reflection rather than a promise of outcome.',
        descriptionZh: '代表细腻、温和与更新的文化符号，用于个人理解与反思，不代表结果承诺。'
      },
      {
        key: 'dragon', nameEn: 'Dragon', nameZh: '龙', identity: 'Momentum',
        traits: ['vitality', 'direction', 'renewal'],
        descriptionEn: 'A cultural symbol of movement and vitality, offered as a personal reflection rather than a promise of outcome.',
        descriptionZh: '代表行动力与生命力的文化符号，用于个人理解与反思，不代表结果承诺。'
      },
      {
        key: 'snake', nameEn: 'Snake', nameZh: '蛇', identity: 'Insight',
        traits: ['observation', 'refinement', 'transformation'],
        descriptionEn: 'A cultural symbol of observation and thoughtful transformation, offered as a personal reflection rather than a fixed character judgment.',
        descriptionZh: '代表观察、沉静与转化的文化符号，用于个人理解与反思，不构成固定性格判断。'
      },
      {
        key: 'horse', nameEn: 'Horse', nameZh: '马', identity: 'Freedom',
        traits: ['movement', 'independence', 'enthusiasm'],
        descriptionEn: 'A cultural symbol of movement and independent spirit, offered as a personal reflection rather than a promise of outcome.',
        descriptionZh: '代表行动、独立与热情的文化符号，用于个人理解与反思，不代表结果承诺。'
      },
      {
        key: 'goat', nameEn: 'Goat', nameZh: '羊', identity: 'Harmony',
        traits: ['imagination', 'care', 'belonging'],
        descriptionEn: 'A cultural symbol of imagination and harmonious belonging, offered as a personal reflection rather than a fixed character judgment.',
        descriptionZh: '代表想象、关怀与和谐归属的文化符号，用于个人理解与反思，不构成固定性格判断。'
      },
      {
        key: 'monkey', nameEn: 'Monkey', nameZh: '猴', identity: 'Ingenuity',
        traits: ['curiosity', 'versatility', 'play'],
        descriptionEn: 'A cultural symbol of curiosity and versatile ingenuity, offered as a personal reflection rather than a promise of outcome.',
        descriptionZh: '代表好奇、灵活与巧思的文化符号，用于个人理解与反思，不代表结果承诺。'
      },
      {
        key: 'rooster', nameEn: 'Rooster', nameZh: '鸡', identity: 'Clarity',
        traits: ['precision', 'expression', 'readiness'],
        descriptionEn: 'A cultural symbol of clarity and expressive readiness, offered as a personal reflection rather than a fixed character judgment.',
        descriptionZh: '代表清晰、表达与准备的文化符号，用于个人理解与反思，不构成固定性格判断。'
      },
      {
        key: 'dog', nameEn: 'Dog', nameZh: '狗', identity: 'Loyalty',
        traits: ['sincerity', 'companionship', 'responsibility'],
        descriptionEn: 'A cultural symbol of sincerity and responsible companionship, offered as a personal reflection rather than a promise of outcome.',
        descriptionZh: '代表真诚、陪伴与责任感的文化符号，用于个人理解与反思，不代表结果承诺。'
      },
      {
        key: 'pig', nameEn: 'Pig', nameZh: '猪', identity: 'Generosity',
        traits: ['warmth', 'openness', 'contentment'],
        descriptionEn: 'A cultural symbol of warmth and open generosity, offered as a personal reflection rather than a fixed character judgment.',
        descriptionZh: '代表温暖、开放与慷慨的文化符号，用于个人理解与反思，不构成固定性格判断。'
      }
    ];

    function mod(value, divisor) {
      return ((value % divisor) + divisor) % divisor;
    }

    function getCnyParts(year) {
      if (year < DATA_BASE_YEAR || year > DATA_LAST_YEAR) return null;
      const value = CNY_MMDD[year - DATA_BASE_YEAR];
      if (!value) return null;
      return { month: Math.floor(value / 100), day: value % 100 };
    }

    function getAnimal(year) {
      return ZODIAC[mod(year - 4, 12)];
    }

    function getEffectiveYears(year, month, boundaryChoice) {
      const cny = getCnyParts(year);
      if (!cny || !Number.isInteger(month) || month < 1 || month > 12) return [];
      if (month < cny.month || (month === cny.month && boundaryChoice === 'before')) return [year - 1];
      if (month === cny.month && boundaryChoice === 'unsure') return [year - 1, year];
      return [year];
    }

    function initTool(tool) {
      if (tool.dataset.zodiacReady === 'true') return;
      tool.dataset.zodiacReady = 'true';

      const currentYear = Number(tool.dataset.currentYear);
      const form = tool.querySelector('.zodiac-check-tool__form');
      const yearInput = tool.querySelector('.zodiac-check-tool__year');
      const monthSelect = tool.querySelector('.zodiac-check-tool__month');
      const yearError = tool.querySelector(`#ZodiacYearError-${tool.dataset.sectionId}`);
      const monthError = tool.querySelector(`#ZodiacMonthError-${tool.dataset.sectionId}`);
      const boundary = tool.querySelector('.zodiac-check-tool__boundary');
      const boundaryQuestion = tool.querySelector('.zodiac-check-tool__boundary-question');
      const boundaryError = tool.querySelector('.zodiac-check-tool__boundary-error');
      const boundaryRadios = Array.from(boundary.querySelectorAll('input[type="radio"]'));
      const result = tool.querySelector('.zodiac-check-tool__result');
      const resultTitle = tool.querySelector('.zodiac-check-tool__result-title');
      const resultContent = tool.querySelector('.zodiac-check-tool__result-content');
      const resultDetail = tool.querySelector('.zodiac-check-tool__result-detail');
      const cycleCta = tool.querySelector('.zodiac-check-tool__cycle-cta');

      if (!form || !yearInput || !monthSelect || !yearError || !monthError) return;
      const recommendationCards = tool.querySelector('[data-zodiac-recommendations]');
      const recommendationIntro = tool.querySelector('[data-zodiac-recommendation-intro]');
      const recommendations = tool.querySelector('.zodiac-recommendations');
      const selectionPanel = tool.querySelector('[data-zodiac-selection]');
      function collapseSelection() {
        selectionPanel.hidden = true;
        tool.classList.add('has-result');
        result.focus({ preventScroll: true });
      }
      tool.querySelector('[data-zodiac-change]').addEventListener('click', () => {
        clearResult();
        const activeMode = tool.querySelector('[data-zodiac-mode][aria-pressed="true"]');
        if (activeMode?.dataset.zodiacMode === 'known') tool.querySelector('[data-known-sign][aria-pressed="true"]')?.focus();
        else yearInput.focus();
      });
      let products = [];
      try { products = JSON.parse(tool.querySelector('[data-zodiac-products]')?.textContent || '[]'); } catch (_) {}
      const guardians = {
        rat: 'Rat · Thousand-Armed Guanyin', ox: 'Ox & Tiger · Akasagarbha', tiger: 'Ox & Tiger · Akasagarbha',
        rabbit: 'Rabbit · Manjushri', dragon: 'Dragon & Snake · Samantabhadra', snake: 'Dragon & Snake · Samantabhadra',
        horse: 'Horse · Mahasthamaprapta', goat: 'Goat & Monkey · Mahavairocana', monkey: 'Goat & Monkey · Mahavairocana',
        rooster: 'Rooster · Acala', dog: 'Dog & Pig · Amitabha', pig: 'Dog & Pig · Amitabha'
      };
      function showRecommendations(record) {
        recommendationCards.replaceChildren();
        recommendations.hidden = !record;
        tool.dataset.hasResult = String(Boolean(record));
        document.dispatchEvent(new CustomEvent('thalune:zodiac-result', { detail: { hasResult: Boolean(record) } }));
        if (!record) {
          recommendationIntro.textContent = 'Choose one sign to see its matching pieces.';
          return;
        }
        products.forEach((product) => {
          if (!product.available || !product.url) return;
          const matches = product.variants.filter((variant) => variant.available && (product.family === 'guardian'
            ? variant.options[0] === guardians[record.key]
            : variant.options[0].startsWith(`${record.nameEn} · `)));
          if (!matches.length) return;
          matches.sort((a, b) => a.priceCents - b.priceCents);
          const variant = matches[0];
          const url = new URL(product.url, window.location.origin);
          const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewId) url.searchParams.set('preview_theme_id', previewId);
          url.searchParams.set('zodiac', record.key);
          if (product.family === 'guardian') url.hash = 'product-options';
          else url.searchParams.set('variant', variant.id);
          const card = document.createElement('article');
          card.className = 'zodiac-piece';
          const imageLink = document.createElement('a');
          imageLink.href = url.href;
          imageLink.className = 'zodiac-piece__image';
          imageLink.tabIndex = -1;
          imageLink.setAttribute('aria-hidden', 'true');
          const imageUrl = variant.image || product.image;
          if (imageUrl) {
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = '';
            image.width = 480; image.height = 480; image.loading = 'lazy';
            imageLink.append(image);
          }
          const label = document.createElement('p');
          label.className = 'zodiac-piece__label';
          label.textContent = product.family === 'guardian' ? 'Guardian' : 'Crystal';
          const heading = document.createElement('h4');
          const link = document.createElement('a');
          link.href = url.href;
          link.textContent = product.family === 'guardian' ? 'Zodiac Guardian Bracelet' : `${record.nameEn} Crystal Bracelet`;
          heading.append(link);
          const description = document.createElement('p');
          description.textContent = variant.options[0].split(' · ').slice(1).join(' · ');
          const amount = document.createElement('p');
          amount.className = 'zodiac-piece__price';
          amount.textContent = `${matches.some((v) => v.priceCents !== variant.priceCents) ? 'From ' : ''}${variant.price}`;
          const action = document.createElement('a');
          action.className = 'zodiac-piece__action'; action.href = url.href;
          action.textContent = product.family === 'guardian' ? 'Choose bead size' : 'View this style';
          const info = document.createElement('div');
          info.className = 'zodiac-piece__info';
          info.append(label, heading, description, amount, action);
          card.append(imageLink, info);
          recommendationCards.append(card);
        });
        recommendationIntro.textContent = recommendationCards.children.length
          ? `The guardian pairing and crystal style associated with ${record.nameEn}.`
          : `No matching ${record.nameEn} styles are available right now. Explore our other bracelets below.`;
      }
      function showKnownSign(record) {
        resultTitle.textContent = 'Your chosen sign';
        resultContent.replaceChildren(createSign(record));
        resultDetail.textContent = '';
        result.dataset.state = 'success'; result.hidden = false;
        tool.querySelectorAll('[data-known-sign]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.knownSign === record.key)));
        showRecommendations(record);
        collapseSelection();
      }
      tool.querySelectorAll('[data-known-sign]').forEach((button) => button.addEventListener('click', () => {
        showKnownSign(ZODIAC.find((record) => record.key === button.dataset.knownSign));
      }));
      tool.querySelectorAll('[data-zodiac-mode]').forEach((button) => button.addEventListener('click', () => {
        const known = button.dataset.zodiacMode === 'known';
        form.hidden = known;
        tool.querySelector('[data-known-signs]').hidden = !known;
        tool.querySelectorAll('[data-zodiac-mode]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        clearResult(); showRecommendations(null);
      }));


      const storyTarget = document.getElementById('zodiac-cycle')
        || document.querySelector('[data-zodiac-cycle]')
        || document.querySelector('.symbol-story-refresh');

      if (storyTarget) {
        if (!storyTarget.id) storyTarget.id = 'zodiac-cycle';
        storyTarget.setAttribute('data-zodiac-cycle', '');
        cycleCta.hidden = false;
        cycleCta.addEventListener('click', () => {
          storyTarget.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      }

      function clearFieldError(input, error) {
        input.removeAttribute('aria-invalid');
        error.textContent = '';
        error.hidden = true;
      }

      function showFieldError(input, error, message) {
        input.setAttribute('aria-invalid', 'true');
        error.textContent = message;
        error.hidden = false;
      }

      function clearResult() {
        selectionPanel.hidden = false;
        tool.classList.remove('has-result');
        result.hidden = true;
        result.dataset.state = 'idle';
        resultTitle.textContent = 'Your zodiac sign';
        resultContent.replaceChildren();
        resultDetail.textContent = '';
        showRecommendations(null);
      }

      function readYear() {
        const raw = yearInput.value.trim();
        if (!raw) return { valid: false, kind: 'empty', value: null };
        if (!/^\d{4}$/.test(raw)) return { valid: false, kind: 'format', value: null };
        const year = Number(raw);
        if (!Number.isInteger(year)) return { valid: false, kind: 'format', value: null };
        if (year < MIN_INPUT_YEAR || year > MAX_INPUT_YEAR) {
          return { valid: false, kind: 'range', value: year };
        }
        return { valid: true, kind: 'valid', value: year };
      }

      function clearBoundary() {
        boundary.hidden = true;
        boundaryQuestion.textContent = '';
        boundaryRadios.forEach((radio) => { radio.checked = false; });
        boundaryError.textContent = '';
        boundaryError.hidden = true;
      }

      function refreshBoundary(moveFocus) {
        const yearState = readYear();
        const month = Number(monthSelect.value);
        const wasHidden = boundary.hidden;
        clearBoundary();
        if (!yearState.valid || !month) return false;

        const cny = getCnyParts(yearState.value);
        if (!cny || month !== cny.month) return false;

        boundaryQuestion.textContent = `In ${yearState.value}, Lunar New Year began on ${MONTH_NAMES[cny.month - 1]} ${cny.day}. Were you born before or after that date?`;
        boundary.hidden = false;
        if (moveFocus && wasHidden) boundaryQuestion.focus({ preventScroll: true });
        return true;
      }

      function createSign(record) {
        const sign = document.createElement('article');
        sign.className = 'zodiac-check-tool__sign';

        const animal = document.createElement('h4');
        animal.className = 'zodiac-check-tool__animal';
        animal.textContent = `${record.nameEn} · ${record.nameZh}`;

        const identity = document.createElement('p');
        identity.className = 'zodiac-check-tool__identity';
        identity.textContent = record.identity;

        const traits = document.createElement('ul');
        traits.className = 'zodiac-check-tool__traits';
        record.traits.forEach((trait) => {
          const item = document.createElement('li');
          item.textContent = trait;
          traits.appendChild(item);
        });

        const copyEn = document.createElement('p');
        copyEn.className = 'zodiac-check-tool__cultural-copy';
        copyEn.textContent = record.descriptionEn;

        const copyZh = document.createElement('p');
        copyZh.className = 'zodiac-check-tool__cultural-copy-zh';
        copyZh.lang = 'zh';
        copyZh.textContent = record.descriptionZh;

        sign.append(animal, identity);
        const selection = document.createElement('button');
        selection.type = 'button';
        selection.className = 'zodiac-check-tool__choose-sign';
        selection.textContent = `Choose ${record.nameEn}`;
        selection.addEventListener('click', () => showKnownSign(record));
        sign.append(selection);
        return sign;
      }

      function renderResult(year, month, boundaryChoice) {
        const cny = getCnyParts(year);
        if (!cny) {
          showFieldError(yearInput, yearError, 'This year is outside the current cultural-reference data range.');
          clearResult();
          yearInput.focus();
          return;
        }

        const cnyLabel = `${MONTH_NAMES[cny.month - 1]} ${cny.day}`;
        const effectiveYears = getEffectiveYears(year, month, boundaryChoice);

        if (effectiveYears.some((effectiveYear) => effectiveYear < DATA_BASE_YEAR || effectiveYear > DATA_LAST_YEAR)) {
          showFieldError(yearInput, yearError, 'This year is outside the current cultural-reference data range.');
          clearResult();
          yearInput.focus();
          return;
        }

        resultContent.replaceChildren();

        if (effectiveYears.length === 2) {
          result.dataset.state = 'uncertain_boundary';
          showRecommendations(null);
          resultTitle.textContent = 'Your sign may fall between two lunar years.';
          effectiveYears.forEach((effectiveYear) => resultContent.appendChild(createSign(getAnimal(effectiveYear))));
          resultDetail.textContent = `In ${year}, Lunar New Year began on ${cnyLabel}. Without your exact birth day, either lunar year may apply.`;
        } else {
          result.dataset.state = 'success';
          showRecommendations(getAnimal(effectiveYears[0]));
          resultTitle.textContent = year > currentYear
            ? `Zodiac cycle preview for ${year}`
            : 'Your zodiac sign';
          resultContent.appendChild(createSign(getAnimal(effectiveYears[0])));

          if (month < cny.month) {
            resultDetail.textContent = `In ${year}, Lunar New Year began on ${cnyLabel}. Your selected month falls before the lunar-year boundary, so this reference uses ${year - 1}.`;
          } else if (month > cny.month) {
            resultDetail.textContent = `In ${year}, Lunar New Year began on ${cnyLabel}. Your selected month falls after the lunar-year boundary.`;
          } else if (boundaryChoice === 'before') {
            resultDetail.textContent = `You selected before Lunar New Year on ${cnyLabel}, so this reference uses ${year - 1}.`;
          } else {
            resultDetail.textContent = `You selected on or after Lunar New Year on ${cnyLabel}, so this reference uses ${year}.`;
          }
        }

        result.hidden = false;
        if (effectiveYears.length === 1) collapseSelection();
      }

      function resetAfterInput(moveBoundaryFocus) {
        clearFieldError(yearInput, yearError);
        clearFieldError(monthSelect, monthError);
        clearResult();
        refreshBoundary(moveBoundaryFocus);
      }

      yearInput.addEventListener('input', () => resetAfterInput(false));
      monthSelect.addEventListener('change', () => resetAfterInput(true));

      boundaryRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          boundaryError.textContent = '';
          boundaryError.hidden = true;
          clearResult();
        });
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clearFieldError(yearInput, yearError);
        clearFieldError(monthSelect, monthError);
        boundaryError.textContent = '';
        boundaryError.hidden = true;
        clearResult();

        const yearState = readYear();
        const month = Number(monthSelect.value);
        let firstInvalid = null;

        if (!yearState.valid) {
          let message = 'Enter your birth year.';
          if (yearState.kind === 'format') message = 'Please enter a whole year, for example 1990.';
          if (yearState.kind === 'range') message = 'Please enter a year between 1900 and 2100.';
          showFieldError(yearInput, yearError, message);
          firstInvalid = yearInput;
        }

        if (!month || month < 1 || month > 12) {
          showFieldError(monthSelect, monthError, 'Select your birth month.');
          firstInvalid = firstInvalid || monthSelect;
        }

        if (firstInvalid) {
          firstInvalid.focus();
          return;
        }

        const cny = getCnyParts(yearState.value);
        if (!cny) {
          showFieldError(yearInput, yearError, 'This year is outside the current cultural-reference data range.');
          yearInput.focus();
          return;
        }

        let boundaryChoice = '';
        if (month === cny.month) {
          if (boundary.hidden) refreshBoundary(false);
          boundaryChoice = boundaryRadios.find((radio) => radio.checked)?.value || '';
          if (!boundaryChoice) {
            boundaryError.textContent = `In ${yearState.value}, Lunar New Year began on ${MONTH_NAMES[cny.month - 1]} ${cny.day}. Please choose an option.`;
            boundaryError.hidden = false;
            boundaryRadios[0].focus();
            return;
          }
        }

        renderResult(yearState.value, month, boundaryChoice);
      });
    }

    function initAll(root) {
      if (root.matches?.('.zodiac-check-tool')) initTool(root);
      root.querySelectorAll?.('.zodiac-check-tool').forEach(initTool);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
